import React, {Component} from 'react';

import {connect} from 'react-redux'
import LoginForm from '../Components/LoginForm'

import {ToastContainer} from "react-toastify";
// import 'react-notifications/lib/notifications.css';
import {Redirect, Navigate} from 'react-router-dom'
import Loader from '../Components/Loader';
import LayoutComponent from '../Components/Layout'
import Config from '../Helpers/Config'

class Login extends Component {

    render() {
        if (!this.props.auth.business) {
            window.location = `${Config.mainUrl('business/submit')}`;
            return null;
        } else if (this.props.auth.logged_in) {
            return <Navigate to={{pathname: `/${this.props.auth.business.slug}/orders`}}/>
        }
        return (
            <LayoutComponent logoUrl={`/login`} {...this.props}>
                <div className='login-page'>
                    <ToastContainer/>
                    <Loader completed={this.props.auth.fetched}>
                        <LoginForm key="12"/>
                    </Loader>
                </div>
            </LayoutComponent>
        )
    }


}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);


